import { ButtonGroupProps, ButtonGroup as MuiButtonGroup, styled } from "@mui/material"

const StyledButtonGroup = styled(MuiButtonGroup)<ButtonGroupProps>({})

export function ButtonGroup(props: ButtonGroupProps) {
    return <StyledButtonGroup {...props} />
}
